import React, { Component } from 'react';

// Components
import { Header } from './components/sections/Header';
import { Challenge } from './components/sections/Challenge';
import { AppPreview } from './components/sections/AppPreview';
import { Solution } from './components/sections/Solution';
import { AppSlideshow } from './components/sections/AppSlideshow';
import { AppSummary } from './components/sections/AppSummary';
import { Results } from './components/sections/Results';
import sr from './libs/scrollReveal';

class App extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount = () => {
        sr.reveal("#challenge");
        sr.reveal("#app-preview");
        sr.reveal("#solution");
        sr.reveal("#app-summary");
        sr.reveal("#app-slideshow");
        sr.reveal("#impact-results");
    }

    render() {
        return (
            <React.Fragment>
                <Header/>
                <Challenge/>
                <AppPreview/>
                <Solution/>
                <AppSlideshow/>
                <AppSummary/>
                <Results />
            </React.Fragment>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx